import { Component, OnInit, Input,OnChanges, SimpleChanges, Injectable } from '@angular/core';
import {FormGroup,FormBuilder} from '@angular/forms';
import{validacionService, listadosService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';
//import {NgbDateStruct, NgbCalendar, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';

const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const DIAS = ['Do','Lu','Ma','Mi','Ju','Vi','Sá']


@Component({
  selector: 'form-datos-complementarios-basicos',
  templateUrl: './datos-complementarios-basicos.component.html',
  providers:[validacionService,listadosService, MessageService, ]
})

export class DatosComplementariosBasicosComponent implements OnInit, OnChanges {
  @Input() complementarios: FormGroup
  @Input() preview: boolean = true
  @Input() estadoForm: number
 
  estadosCiviles
  etnias
  tiposDocentes
  
  constructor(
    private listadosService:listadosService,
    private val: validacionService
  ) { }

  ngOnChanges(changes:SimpleChanges) {
    console.log("datos complementarios", changes)
    if(changes.preview != undefined
      && changes.preview.currentValue != undefined 
      && changes.preview.currentValue) this.onPreview()
    
    if(changes.estadoForm != undefined
        && changes.estadoForm.currentValue != undefined ) 
        this.asignarCampoDefecto()
    

  }

  ngOnInit() {
    this.listadosService.grupos('G_ESTADO_CIVIL,G_ETNIA,G_TIPOS_DOCENTES').subscribe(
      listas =>{
        if(listas != null){
          this.estadosCiviles = listas['G_ESTADO_CIVIL'].orden
          this.etnias = listas['G_ETNIA'].orden
          this.tiposDocentes = listas['G_TIPOS_DOCENTES'].orden
          this.asignarCampoDefecto()
        }
      }
    )
  }

  asignarCampoDefecto(){
    if(this.complementarios.get('tipoDocente').value == null && this.tiposDocentes != null)
    this.complementarios.patchValue({tipoDocente: this.val.gruposDefecto(this.tiposDocentes, 2)})

    if(this.complementarios.get('estadoCivil').value == null && this.estadosCiviles != null)
      this.complementarios.patchValue({estadoCivil: this.val.gruposDefecto(this.estadosCiviles, 2)})

    if(this.complementarios.get('etnia').value == null && this.etnias != null)
      this.complementarios.patchValue({etnia: this.val.gruposDefecto(this.etnias, 2)})
  }


  onPreview(){
    console.log("entre disable")
    this.complementarios.get('fechaIngreso').disable()
    this.complementarios.get('tipoDocente').disable()
    this.complementarios.get('estadoCivil').disable()
    this.complementarios.get('etnia').disable()
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/formularios/datos-complementarios-basicos.component.ts